export const ALLOWED_ROLES = ["Super Admin", "Admin"];
export const ALLOWED_CITY_ROLE = ["Admin"];
export const ALLOWED_SUPER_ADMIN_ROLE = ["Super Admin"];
export const SUPER_ADMIN = "Super Admin";
export const ADMIN = "Admin";
